const ths = ({ isOffline } = {}) => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First name',
    intlKey: 'table.first_name',
    sortableId: 'award.participant.firstName'
  },
  {
    id: 3,
    label: 'Last name',
    intlKey: 'table.last_name',
    sortableId: 'award.participant.lastName'
  },
  {
    id: 4,
    label: 'Previous Level',
    intlKey: 'table.previous_level',
    sortable: false
  },
  {
    id: 5,
    label: 'Current Level',
    intlKey: 'table.current_level',
    sortableId: 'award.awardLevel.value'
  },
  {
    id: 6,
    label: 'Date Submitted to Award Office Sign-off',
    intlKey: 'table.date_submitted_to_office_signoff',
    sortableId: 'award.leaderSignoffDate'
  },
  {
    id: 7,
    label: 'Weeks completed / required',
    intlKey: 'table.weeks_completed_required',
    sortable: false
  },
  {
    id: 8,
    label: 'Note',
    intlKey: 'table.note',
    sortable: false
  },
  {
    id: 9,
    label: 'Award mode',
    intlKey: 'table.award_mode',
    sortable: false,
    hide: !isOffline
  },
  {
    id: 10,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
